"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var RssBoxIcon_1 = __importDefault(require("mdi-react/RssBoxIcon"));
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
// @ts-ignore
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../../utils/styles");
var Div_1 = __importDefault(require("../Div"));
var Image_1 = __importDefault(require("../Image"));
var Text_1 = __importDefault(require("../Text"));
var KeskoFeedHeadline_1 = __importDefault(require("./KeskoFeedHeadline"));
var OfferFeedPrice_1 = __importDefault(require("./OfferFeedPrice"));
var LeftArea = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 50%;\n  height: calc(100% - 200px);\n  float: left;\n"], ["\n  width: 50%;\n  height: calc(100% - 200px);\n  float: left;\n"])));
var RightArea = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 50%;\n  height: calc(100% - 200px);\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  float: right;\n"], ["\n  width: 50%;\n  height: calc(100% - 200px);\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  float: right;\n"])));
var FeedIconContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  bottom: 0px;\n  right: 0px;\n  position: absolute;\n"], ["\n  bottom: 0px;\n  right: 0px;\n  position: absolute;\n"])));
var offerStyles = {
    headline: {
        width: '100%',
        height: '200px',
        zIndex: 99
    },
    offerImageArea: {
        height: '100%'
    }
};
var KeskoFeedOffers = function (_a) {
    var 
    // mediaKeys,
    templateChildren = _a.templateChildren, styles = _a.styles, items = _a.items, id = _a.id;
    var item = items.length > 0 ? items[0] : undefined;
    if (!item) {
        return react_1.default.createElement(react_1.Fragment, null);
    }
    var name = item.name, info = item.info, imagePath = item.imagePath, salePrice = item.salePrice, salesUnit = item.salesUnit, isPlusOffer = item.isPlusOffer, validFrom = item.validFrom, visibleTo = item.visibleTo;
    var headlineProps = {
        styles: offerStyles.headline,
        isPlusOffer: isPlusOffer
    };
    var startDate = (0, moment_1.default)(validFrom, 'DD.MM.YYYY');
    var endDate = (0, moment_1.default)(visibleTo, 'DD.MM.YYYY');
    return (react_1.default.createElement(Div_1.default, { id: id, styles: (0, styles_1.removeNullValues)(styles) },
        react_1.default.createElement(KeskoFeedHeadline_1.default, __assign({}, headlineProps)),
        react_1.default.createElement(LeftArea, null,
            react_1.default.createElement(Text_1.default, { id: 'name', styles: (0, styles_1.getTemplateChildrenStyles)(templateChildren, 0), value: name || '', textfit: { max: 60, mode: 'multi' } }),
            info && (react_1.default.createElement(Text_1.default, { id: 'info', styles: (0, styles_1.getTemplateChildrenStyles)(templateChildren, 1), value: info || '', textfit: { max: 40, mode: 'multi' } })),
            salePrice && (react_1.default.createElement(OfferFeedPrice_1.default, { styles: (0, styles_1.getTemplateChildrenStyles)(templateChildren, 2), salePrice: salePrice, salesUnit: salesUnit })),
            react_1.default.createElement("br", { style: { clear: 'both' } }),
            validFrom && visibleTo && (react_1.default.createElement(Text_1.default, { id: 'valid', styles: (0, styles_1.getTemplateChildrenStyles)(templateChildren, 3), value: "Voimassa ".concat(startDate.format('D.M'), ".-").concat(endDate.format('D.M.YYYY')) }))),
        react_1.default.createElement(RightArea, null, imagePath && (react_1.default.createElement(Image_1.default, { styles: (0, styles_1.getTemplateChildrenStyles)(templateChildren, 4), src: imagePath, alt: 'offer' }))),
        react_1.default.createElement(FeedIconContainer, null,
            react_1.default.createElement(RssBoxIcon_1.default, { size: '50px', color: '#1e88e5' }))));
};
exports.default = KeskoFeedOffers;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=KeskoFeedOffers.js.map